import { render, staticRenderFns } from "./flats-crm-page.vue?vue&type=template&id=57bb03e4"
import script from "./flats-crm-page.vue?vue&type=script&lang=js"
export * from "./flats-crm-page.vue?vue&type=script&lang=js"
import style0 from "./flats-crm-page.vue?vue&type=style&index=0&id=57bb03e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports